import { WidgetRegistry } from "@Widgets/types";
import { Router as AppRouter } from "@modules/App/Containers/Router/Router";
import { Footer } from "@App/Components/Footer/Footer";

const appWidgetRegistry: Pick<WidgetRegistry, "App.Router" | "Core.Footer"> = {
  "App.Router": {
    Component: AppRouter,
  },
  "Core.Footer": {
    Component: Footer,
  },
};

export default appWidgetRegistry;
